import { atom } from 'jotai';
import { metricPanelPersistenceAtom } from '@src/components/metrics-panel-hz/atoms';
import {
  globalFilterRulesExpandedAtom,
  globalFilterAppendedAtomStatusAtom,
} from '@components/filter/global-atoms';
import { currentKpiIdAtom } from '@src/atoms/panels';
// import { dimensionPanelPersistenceAtom } from "@src/components/dimension-panel-hz/atoms";

// pull in all sectional atoms here for persistence
export const persistenceAtom = atom((get) => {
  return {
    metricPanel: get(metricPanelPersistenceAtom),
    globalFilterRulesExpanded: get(globalFilterRulesExpandedAtom),
    globalFilterAppendedAtomStatus: get(globalFilterAppendedAtomStatusAtom),
    // currentKpiId: get(currentKpiIdAtom),
    currentKpiIdSelected: get(currentKpiIdAtom),
    // no items to persist now
    // dimensionPanel: get(dimensionPanelPersistenceAtom),
  };
});

export const blueBarAtom = atom(true);
